import { Modal } from "@/components/site/Modal";

export const VideoModal = ({ open, onClose, videoId, title, description }) => (
  <Modal open={open} onClose={onClose} title={title} maxWidth="max-w-3xl">
    <div className="p-6 sm:p-9 clear-both">
      <h3 className="font-serif text-2xl md:text-3xl text-legacy leading-tight pr-10">{title}</h3>
      {description && (
        <p className="mt-3 text-slate text-sm md:text-base leading-relaxed">{description}</p>
      )}
      <div className="mt-6 aspect-video w-full rounded-card overflow-hidden bg-black border border-taupe/40">
        {videoId ? (
          <iframe
            className="h-full w-full"
            src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
            title={title}
            loading="lazy"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="video-modal-iframe"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-center px-6">
            <p className="text-taupe text-sm">
              Video URL pending. The final reader-review video link has not been provided yet.
            </p>
          </div>
        )}
      </div>
    </div>
  </Modal>
);
